/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AcceptVisitRequestResponse,
  HTTPValidationError,
  MarkVisitAsExpiredResponse,
  VisitFormType,
} from '../models/index';
import {
    AcceptVisitRequestResponseFromJSON,
    AcceptVisitRequestResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    MarkVisitAsExpiredResponseFromJSON,
    MarkVisitAsExpiredResponseToJSON,
    VisitFormTypeFromJSON,
    VisitFormTypeToJSON,
} from '../models/index';

export interface AcceptVisitRequestApiV1VisitRequestsVisitRequestAcceptPatchRequest {
    visitRequest: string;
}

export interface GetListingAddressApiV1VisitRequestsVisitRequestIdListingAddressGetRequest {
    visitRequestId: string;
}

export interface MarkVisitAsExpiredApiV1VisitRequestsVisitIdExpirePatchRequest {
    visitId: string;
}

export interface MarkVisitRequestAsRejectedApiV1VisitRequestsVisitRequestIdRejectPatchRequest {
    visitRequestId: string;
}

export interface SendVisitRequestBulkApiV1VisitRequestsSendBulkListingIdVisitFormTypeGetRequest {
    listingId: string;
    visitFormType: VisitFormType;
}

/**
 * 
 */
export class VisitRequestsApi extends runtime.BaseAPI {

    /**
     * Accept a visit request by visit request ID.  This endpoint handles the acceptance of visit requests. It will: 1. Validate that the visit request exists and is in pending status 2. Validate that the associated visit exists and is in pending status 3. Accept the visit request using the agent linked to the request 4. Assign the agent to the visit and mark it as completed 5. Expire all other pending visit requests for the same visit 6. Schedule Showami tasks if the accepting agent is of type PREFERRED  Args:     visit_request_id: The ID of the visit request to accept     current_user: The current authenticated user (optional - not required for acceptance)  Returns:     AcceptVisitRequestResponse with the updated visit  Raises:     HTTPException: If the visit request or visit is not found, not in pending status, or other validation errors
     * Accept Visit Request
     */
    async acceptVisitRequestApiV1VisitRequestsVisitRequestAcceptPatchRaw(requestParameters: AcceptVisitRequestApiV1VisitRequestsVisitRequestAcceptPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AcceptVisitRequestResponse>> {
        if (requestParameters.visitRequest === null || requestParameters.visitRequest === undefined) {
            throw new runtime.RequiredError('visitRequest','Required parameter requestParameters.visitRequest was null or undefined when calling acceptVisitRequestApiV1VisitRequestsVisitRequestAcceptPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/visit-requests/{visit_request}/accept`.replace(`{${"visit_request"}}`, encodeURIComponent(String(requestParameters.visitRequest))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AcceptVisitRequestResponseFromJSON(jsonValue));
    }

    /**
     * Accept a visit request by visit request ID.  This endpoint handles the acceptance of visit requests. It will: 1. Validate that the visit request exists and is in pending status 2. Validate that the associated visit exists and is in pending status 3. Accept the visit request using the agent linked to the request 4. Assign the agent to the visit and mark it as completed 5. Expire all other pending visit requests for the same visit 6. Schedule Showami tasks if the accepting agent is of type PREFERRED  Args:     visit_request_id: The ID of the visit request to accept     current_user: The current authenticated user (optional - not required for acceptance)  Returns:     AcceptVisitRequestResponse with the updated visit  Raises:     HTTPException: If the visit request or visit is not found, not in pending status, or other validation errors
     * Accept Visit Request
     */
    async acceptVisitRequestApiV1VisitRequestsVisitRequestAcceptPatch(requestParameters: AcceptVisitRequestApiV1VisitRequestsVisitRequestAcceptPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AcceptVisitRequestResponse> {
        const response = await this.acceptVisitRequestApiV1VisitRequestsVisitRequestAcceptPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Listing Address
     */
    async getListingAddressApiV1VisitRequestsVisitRequestIdListingAddressGetRaw(requestParameters: GetListingAddressApiV1VisitRequestsVisitRequestIdListingAddressGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.visitRequestId === null || requestParameters.visitRequestId === undefined) {
            throw new runtime.RequiredError('visitRequestId','Required parameter requestParameters.visitRequestId was null or undefined when calling getListingAddressApiV1VisitRequestsVisitRequestIdListingAddressGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/visit-requests/{visit_request_id}/listing-address`.replace(`{${"visit_request_id"}}`, encodeURIComponent(String(requestParameters.visitRequestId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get Listing Address
     */
    async getListingAddressApiV1VisitRequestsVisitRequestIdListingAddressGet(requestParameters: GetListingAddressApiV1VisitRequestsVisitRequestIdListingAddressGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getListingAddressApiV1VisitRequestsVisitRequestIdListingAddressGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark Visit As Expired
     */
    async markVisitAsExpiredApiV1VisitRequestsVisitIdExpirePatchRaw(requestParameters: MarkVisitAsExpiredApiV1VisitRequestsVisitIdExpirePatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkVisitAsExpiredResponse>> {
        if (requestParameters.visitId === null || requestParameters.visitId === undefined) {
            throw new runtime.RequiredError('visitId','Required parameter requestParameters.visitId was null or undefined when calling markVisitAsExpiredApiV1VisitRequestsVisitIdExpirePatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/visit-requests/{visit_id}/expire`.replace(`{${"visit_id"}}`, encodeURIComponent(String(requestParameters.visitId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkVisitAsExpiredResponseFromJSON(jsonValue));
    }

    /**
     * Mark Visit As Expired
     */
    async markVisitAsExpiredApiV1VisitRequestsVisitIdExpirePatch(requestParameters: MarkVisitAsExpiredApiV1VisitRequestsVisitIdExpirePatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkVisitAsExpiredResponse> {
        const response = await this.markVisitAsExpiredApiV1VisitRequestsVisitIdExpirePatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark a visit request as rejected by visit request ID.  This endpoint handles marking a visit request as rejected. It will: 1. Validate that the visit request exists 2. Update the visit request status to REJECTED  Args:     visit_request_id: The ID of the visit request to mark as rejected     current_user: The current authenticated user (optional)  Returns:     None  Raises:     HTTPException: If the visit request is not found or other validation errors
     * Mark Visit Request As Rejected
     */
    async markVisitRequestAsRejectedApiV1VisitRequestsVisitRequestIdRejectPatchRaw(requestParameters: MarkVisitRequestAsRejectedApiV1VisitRequestsVisitRequestIdRejectPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.visitRequestId === null || requestParameters.visitRequestId === undefined) {
            throw new runtime.RequiredError('visitRequestId','Required parameter requestParameters.visitRequestId was null or undefined when calling markVisitRequestAsRejectedApiV1VisitRequestsVisitRequestIdRejectPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/visit-requests/{visit_request_id}/reject`.replace(`{${"visit_request_id"}}`, encodeURIComponent(String(requestParameters.visitRequestId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Mark a visit request as rejected by visit request ID.  This endpoint handles marking a visit request as rejected. It will: 1. Validate that the visit request exists 2. Update the visit request status to REJECTED  Args:     visit_request_id: The ID of the visit request to mark as rejected     current_user: The current authenticated user (optional)  Returns:     None  Raises:     HTTPException: If the visit request is not found or other validation errors
     * Mark Visit Request As Rejected
     */
    async markVisitRequestAsRejectedApiV1VisitRequestsVisitRequestIdRejectPatch(requestParameters: MarkVisitRequestAsRejectedApiV1VisitRequestsVisitRequestIdRejectPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.markVisitRequestAsRejectedApiV1VisitRequestsVisitRequestIdRejectPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sendvisitrequestbulk
     */
    async sendVisitRequestBulkApiV1VisitRequestsSendBulkListingIdVisitFormTypeGetRaw(requestParameters: SendVisitRequestBulkApiV1VisitRequestsSendBulkListingIdVisitFormTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling sendVisitRequestBulkApiV1VisitRequestsSendBulkListingIdVisitFormTypeGet.');
        }

        if (requestParameters.visitFormType === null || requestParameters.visitFormType === undefined) {
            throw new runtime.RequiredError('visitFormType','Required parameter requestParameters.visitFormType was null or undefined when calling sendVisitRequestBulkApiV1VisitRequestsSendBulkListingIdVisitFormTypeGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/visit-requests/send-bulk/{listing_id}/{visit_form_type}`.replace(`{${"listing_id"}}`, encodeURIComponent(String(requestParameters.listingId))).replace(`{${"visit_form_type"}}`, encodeURIComponent(String(requestParameters.visitFormType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Sendvisitrequestbulk
     */
    async sendVisitRequestBulkApiV1VisitRequestsSendBulkListingIdVisitFormTypeGet(requestParameters: SendVisitRequestBulkApiV1VisitRequestsSendBulkListingIdVisitFormTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.sendVisitRequestBulkApiV1VisitRequestsSendBulkListingIdVisitFormTypeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
